import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  parseFractionLikeInput as parseFraction,
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // 3..20
  const a = pick(A);
  const Ob = 4 * a;
  return { type: "SquarePerimeterFromSideTask", data: { a, Ob } };
}

export function renderTask({ data }) {
  const { a } = data;
  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      Dany jest kwadrat o boku <InlineMath math={`a=${a}`} />.
      Oblicz jego obwód <InlineMath math={'Ob'} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <FractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="Ob"
      placeholder="np. 28"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.Ob) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`Ob=${data.Ob}`} />;

export function renderExplanation({ data }) {
  const { a, Ob } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <div><strong>Krok 1.</strong> Wzór na obwód kwadratu: <InlineMath math={'Ob=4a'} />.</div>
      <BlockMath math={`Ob=4\\cdot ${a}=${Ob}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, 'Ob')} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
